import { Directive, ElementRef, Renderer2, HostListener, Input, OnChanges } from '@angular/core';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router';
import { SectionsService } from '../_services/sections.service';
import * as $ from "jquery";

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Directive({
	selector: '[main-menu]'
})
export class MenuAnimationDirective {

	private unsubscribe$ = new Subject<void>();

	public sections;
	public menu;
	public menuList;
	public menuItem;
	public menuLink;
	public menuLinkActive;
	
	public newRoute;
	
	@Input() menuActivePosition: number;
	
	constructor(private _elRef: ElementRef, private _renderer: Renderer2, private _router: Router, private _sectionsService: SectionsService) {
		this.sections = this._sectionsService.getSections();

		_router.events
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe( (event: Event) => {
            if (event instanceof NavigationEnd) {
                //this.newRoute = this._router.url.replace('/', '');
                //let section = this.sections.find(data => data.routeName === this.newRoute);
                
                //this.positionItem(section.position);
            }
        });
	}

	ngOnInit() {
		this._sectionsService.changeSection
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(position => {
			let section = this.sections.find(data => data.position === this._sectionsService.getCurrentSectionPosition());
		});
	}

	ngAfterViewInit() {
		this.menu = $(this._elRef.nativeElement);
		this.menuList = $(this._elRef.nativeElement).find('.main-menu__list');
		this.menuItem = $(this._elRef.nativeElement).find('.main-menu__item');
		this.menuLink = $(this._elRef.nativeElement).find('.main-menu__item a');

		this.menuLinkActive = $(this._elRef.nativeElement).find('.main-menu__item a');

		//this.positionItem(this.menuActivePosition)
	}

	private positionItem(activePos){
		let base = this;
		let menuH;
		if(base.menu){
			menuH = base.menu.innerHeight();
		}

		if(base.menuItem){
			base.menuItem.each(function(index, value){
				if($(this).attr('data-position') == activePos){
					let activeH = $(this).innerHeight();
					let activeTop = $(this).position().top;
					let activePosition = (menuH/2) - activeTop - (activeH/2) ;
					base.menuList.css('transform', 'translate3d(0,'+ activePosition +'px,0)');
					return false;
				}
			})
		}
	}

	
	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}





}
